import React, { useEffect } from "react";
import SubLayout from "../../components/layout/SubLayout";
import {
  Row,
  Col,
  Table,
  Modal,
  Input,
  Form,
  message,
  Button,
  Tooltip,
  Select,
  Divider,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import DeleteIcon from "../../Assets/delete.svg";
import EditIcon from "../../Assets/editIcon.svg";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import API_MANAGER from "../../API";
import { DeleteCandidate } from "../../components/common/Popup";
// import CustomPagination from "../../components/common/CustomPagination";

function PickListDetail() {
  const { state } = useLocation();
  const [edit_detail, setEditDetail] = useState(false);
  const [Id, setId] = useState("");
  const [data, setData] = useState([]);
  const [fundUsi, setFundUsi] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('name');
  const [openDeleteModal, setDeleteModal] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [createDetail, setCreateDetail] = useState(false);
  const [rowData, setRowData] = useState({});
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [search, setSearch] = useState(null);
  const [fundUsiSearch, setFundUsiSearch] = useState("");
  const [fundUsiLoading, setFundUsiLoading] = useState(false);
  const [fundUsiOpen, setFundUsiOpen] = useState(false);
  // const [page, setPage] = useState(1);

  const userType = localStorage.getItem("userType");

  const column = [
    {
      title: "No.",
      dataIndex: "si",
      width: "80px",
      render: (item, row, index) => {
        return (
          <span className="cursor-pointer">{10 * (1 - 1) + index + 1}</span>
        );
      },
    },
    {
      title: "Picklist Value's",
      dataIndex: "name",
      filters: [
        {
          text: "A-Z",
          value: "name",
        },
        {
          text: "Z-A",
          value: "-name",
        },
        {
          text: "Latest",
          value: "-createdAt",
        },
        {
          text: "Oldest",
          value: "createdAt",
        },
      ],
      defaultFilteredValue: ["name"],
      filterMultiple: false,
      onFilter: (value, record) => {
        setFilter(value);
        return record;
      },
    },
    ...(state.title === "FUND_NAME"
      ? [
          {
            title: "Fund USI/ABN",
            dataIndex: "correspondingValue",
            render: (value) => {
              if (!value) return "-";
              if (typeof value === "object") {
                return value?.name || "-";
              }
              const matched = fundUsi?.find(
                (e) => e.id === value || e._id === value
              );
              return matched?.name || value || "-";
            },
          },
        ]
      : []),
    {
      title: "Action",
      dataIndex: "delete",
      render: (_, row) => (
        <>
          <Tooltip title={userType === "admin" ? "" : "Not Authorised"}>
            <span>
              {userType === "admin" ? (
                <img
                  style={{ width: "35px" }}
                  src={EditIcon}
                  alt="edit"
                  className="cursor-pointer"
                  onClick={() => {
                    setEditDetail(true);
                    setRowData(row);
                    setId(row._id);
                  }}
                />
              ) : (
                <img
                  style={{ width: "35px" }}
                  src={EditIcon}
                  alt="edit"
                  className="cursor-pointer"
                />
              )}
            </span>
            <span>
              {userType === "admin" ? (
                <img
                  src={DeleteIcon}
                  alt="delete"
                  style={{ width: "35px" }}
                  className="cursor-pointer"
                  onClick={() => {
                    setId(row._id);
                    setDeleteModal(true);
                  }}
                />
              ) : (
                <img
                  src={DeleteIcon}
                  alt="delete"
                  style={{ width: "35px" }}
                  className="cursor-pointer"
                />
              )}
            </span>
          </Tooltip>
        </>
      ),
    },
  ];
  const getCorrespondingName = (value) => {
    if (!value) return undefined;
    if (typeof value === "object") return value?.name || undefined;
    const matched = fundUsi?.find((e) => e.id === value || e._id === value);
    return matched?.name || value || undefined;
  };
  const getCorrespondingId = (value) => {
    if (!value) return null;
    if (typeof value === "object") return value?._id || value?.id || null;
    const matched = fundUsi?.find(
      (e) => e.id === value || e._id === value || e.name === value
    );
    return matched?._id || matched?.id || null;
  };
  const deleteConfirm = async () => {
    try {
      setConfirmLoading(true);
      await API_MANAGER.deletePicklist(Id);
      message.success("Successfully deleted picklist value");
      getData();
      if (state.title === "FUND_NAME") {
        getFundUsiList();
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message?.message || "Something went wrong"
      );
    }
    setConfirmLoading(false);
    setDeleteModal(false);
  };
  const handleUpdate = async (values) => {
    setLoading(true);
    try {
      if (createDetail) {
        let params = { type: state.title, name: values.name };
        if (state.title === "FUND_NAME") {
          params.correspondingValue = values.correspondingValue;
        }
        await API_MANAGER.createPickListTag(params);
        form1.resetFields();
        setFundUsiSearch("");
        message.success("Successfully created picklist value");
        setCreateDetail(false);
      } else if (state.title === "FUND_NAME") {
        const usiName = values.correspondingValue?.trim?.() || values.correspondingValue;
        const previousUsiTagId = getCorrespondingId(rowData?.correspondingValue);
        // Update FUND_NAME whenever name or USI is edited
        await API_MANAGER.updatePickListTag(
          {
            tagId: Id,
            name: values.name,
            correspondingValue: usiName,
          },
          "FUND_NAME"
        );
        // Also call FUND_USI_ABN API whenever either field is edited
        if (previousUsiTagId && usiName) {
          await API_MANAGER.updatePickListTag(
            { tagId: previousUsiTagId, name: usiName },
            "FUND_USI_ABN"
          );
        }
        message.success("Successfully updated picklist value");
        setEditDetail(false);
        form.resetFields();
      } else {
        await API_MANAGER.updatePickListTag(
          { tagId: Id, name: values.name },
          state.title
        );
        message.success("Successfully updated picklist value");
        setEditDetail(false);
      }
      await getData();
      if (state.title === "FUND_NAME") {
        await getFundUsiList();
      }
    } catch (err) {
      message.error(err?.response?.data?.message?.message);
    }
    setLoading(false);
  };
  const getFundUsiList = async () => {
    setFundUsiLoading(true);
    let tags = [];
    try {
      const response = await API_MANAGER.getPickListTags({
        type: "FUND_USI_ABN",
        sort: "name",
        limit: 1000,
      });
      tags = response?.data?.data?.tags || [];
      setFundUsi(tags);
    } catch {
      message.error("Unable to load Fund USI/ABN values");
    }
    setFundUsiLoading(false);
    return tags;
  };
  const handleCreateFundUsi = async () => {
    const name = fundUsiSearch?.trim();
    if (!name) return;
    setFundUsiLoading(true);
    try {
      await API_MANAGER.createPickListTag({
        type: "FUND_USI_ABN",
        name: name,
      });
      const tags = await getFundUsiList();
      const created = tags?.find(
        (e) => String(e?.name)?.toLowerCase() === name?.toLowerCase()
      );
      const value = created?.name || name;
      form1.setFieldValue("correspondingValue", value);
      setFundUsiSearch("");
      setFundUsiOpen(false);
      message.success("Successfully created Fund USI/ABN value");
    } catch (err) {
      message.error(
        err?.response?.data?.message?.message || "Something went wrong"
      );
    }
    setFundUsiLoading(false);
  };
  const getData = async () => {
    setLoading(true);
    try {
      const response = await API_MANAGER.getPickListTags({
        type: state.title,
        search: search,
        sort: filter,
        limit: 1000,
      });
      setData(response?.data?.data?.tags);
    } catch {
      message.error("Something went wrong");
    }
    setLoading(false);
  };
  useEffect(() => {
    getData();
  }, [search,filter]);
  useEffect(() => {
    if (state.title === "FUND_NAME") {
      getFundUsiList();
    }
  }, []);
  useEffect(() => {
    if (edit_detail && rowData?.name) {
      form.setFieldsValue({
        name: rowData?.name,
        correspondingValue: getCorrespondingName(rowData?.correspondingValue),
      });
    }
  }, [rowData, edit_detail, fundUsi]);
  const trimmedFundUsiSearch = fundUsiSearch?.trim();
  const showAddFundUsi =
    !!trimmedFundUsiSearch &&
    !fundUsi?.some(
      (e) =>
        String(e?.name)?.toLowerCase() === trimmedFundUsiSearch?.toLowerCase()
    );
  const renderFundUsiSelect = () => (
    <Form.Item name="correspondingValue" label="Fund USI/ABN">
      <Select
        placeholder="Fund USI ABN value"
        showSearch
        allowClear
        loading={fundUsiLoading}
        open={fundUsiOpen}
        onDropdownVisibleChange={(open) => {
          setFundUsiOpen(open);
          if (!open) setFundUsiSearch("");
        }}
        searchValue={fundUsiSearch}
        onSearch={(value) => setFundUsiSearch(value)}
        optionFilterProp="children"
        filterOption={(input, option) =>
          String(option?.children)
            ?.toLowerCase()
            ?.indexOf(input?.toLowerCase()) >= 0
        }
        dropdownRender={(menu) => (
          <>
            {menu}
            {showAddFundUsi && (
              <>
                <Divider style={{ margin: "4px 0" }} />
                <Button
                  type="text"
                  block
                  icon={<PlusOutlined />}
                  loading={fundUsiLoading}
                  className="add_fund_usi_button"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={handleCreateFundUsi}
                >
                  {`Create "${trimmedFundUsiSearch}"`}
                </Button>
              </>
            )}
          </>
        )}
      >
        {fundUsi.map((e, key) => {
          return (
            <Select.Option key={key} value={e.name}>
              {e.name}
            </Select.Option>
          );
        })}
      </Select>
    </Form.Item>
  );
  return (
    <SubLayout page="Picklist Detail View" showBack>
      <Row className="picklist_container">
        <Col xs={15}>
          <p className="heading">{state.heading}</p>
        </Col>
        <Col
          className="search_container"
          xs={5}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Input.Search
            placeholder="Search"
            value={search}
            allowClear
            onChange={(e) => setSearch(e?.target?.value)}
          />
          {/* <p className="heading">{state.heading}</p> */}
        </Col>
        <Col
          xs={4}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            className="bulk_button"
            onClick={() => {
              setCreateDetail(true);
            }}
          >
            Create Picklist Value
          </Button>
        </Col>
        <Col xs={20} className="detail_container">
          <Row>
            <Col xs={24} className="table_container">
              <Table
                columns={column}
                dataSource={data}
                pagination={false}
                loading={loading}
                scroll={{
                  y: "calc(100vh - 400px)",
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal
        title={"Edit Value"}
        open={edit_detail}
        onCancel={() => {
          setEditDetail(false);
          form.resetFields();
        }}
        centered
        footer={false}
      >
        <Form form={form} layout="vertical" onFinish={handleUpdate}>
          <Row>
            <Col xs={24}>
              <Form.Item
                name="name"
                label={state.title === "FUND_NAME" ? "Fund Name" : undefined}
              >
                <Input className="input" placeholder="Enter picklist value" />
              </Form.Item>
              {state.title === "FUND_NAME" && (
                <Form.Item name="correspondingValue" label="Fund USI/ABN">
                  <Input
                    className="input"
                    placeholder="Enter Fund USI/ABN number"
                  />
                </Form.Item>
              )}
              <Col md={24} className="buttonCol">
                <Form.Item>
                  <Button
                    className="btn"
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                  >
                    Save
                  </Button>
                </Form.Item>
              </Col>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        title={"Create Value"}
        open={createDetail}
        onCancel={() => {
          setCreateDetail(false);
          setFundUsiSearch("");
          setFundUsiOpen(false);
        }}
        centered
        footer={false}
      >
        <Form form={form1} layout="vertical" onFinish={handleUpdate}>
          <Row>
            <Col xs={24} className="passwordInput">
              <Form.Item name="name">
                <Input className="input" placeholder="Enter picklist value" />
              </Form.Item>
              {state.title === "FUND_NAME" && renderFundUsiSelect()}
              <Col md={24} className="buttonCol">
                <Form.Item>
                  <Button
                    className="btn"
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                  >
                    Save
                  </Button>
                </Form.Item>
              </Col>
            </Col>
          </Row>
        </Form>
      </Modal>
      <DeleteCandidate
        confirmDelete={deleteConfirm}
        visible={openDeleteModal}
        text={"Picklist Value"}
        setVisible={setDeleteModal}
        loading={confirmLoading}
      />
    </SubLayout>
  );
}
export default PickListDetail;
